import Vue from "vue";
let CONSTANT = {
    data: [
        {code:'banner_index',id:'1',name:"首页轮播图"},
        {code:'banner_news',id:'2',name:"新闻轮播图"},
        {code:'banner_notice',id:'3',name:"公告轮播图"},
        {code:'banner_book',id:'4',name:"图书分类轮播图"},
        {code:'reading_book',id:'7',name:"商务阅读分类轮播图"},
        {code:'banner_leader',id:'5',name:"领导关怀轮播图"},
        {code:'news_id',id:'7',name:"新闻动态"},
        {code:'leader_id',id:'101',name:"领导关怀"},
        {code:'notice_id',id:'8',name:"公告动态"},
        {code:'recruit_id',id:'13',name:"人才招聘"},
        {code:'newbook_id',id:'1',name:"新书推荐"},
        {code:'boutiquebook_id',id:'2',name:"精品图书"},
        {code:'requestbook_id',id:'3',name:"课件索取"},
        {code:'navbook_id',id:'4',name:"图书分类"},
        {code:'reading_id',id:'18',name:"商务阅读分类"},
        {code:'navabout_id',id:'3',name:"关于我们"},
        {code:'navconnect_id',id:'6',name:"联系我们"},
        {code:'nav_classid',id:'8',name:"书目分类"},
    ],
    getDateByCode :function(code){
        let item  = null 
        for(let i=0;i<this.data.length ; i ++){
            if(code == this.data[i].code){
                item = this.data[i]
                break
            }
        }
        return item
    }

}

Vue.prototype.CONSTANT = CONSTANT;
export default {};
